export var BookingStatus;
(function (BookingStatus) {
    BookingStatus[BookingStatus["Pending"] = 1] = "Pending";
    BookingStatus[BookingStatus["Approved"] = 2] = "Approved";
    BookingStatus[BookingStatus["Rejected"] = 3] = "Rejected";
    BookingStatus[BookingStatus["Cancelled"] = 4] = "Cancelled";
    BookingStatus[BookingStatus["PendingCancellation"] = 5] = "PendingCancellation";
    BookingStatus[BookingStatus["Withdrawn"] = 6] = "Withdrawn";
})(BookingStatus || (BookingStatus = {}));
export const BookingStatusMapping = {
    [BookingStatus.Pending]: 'Pending',
    [BookingStatus.Approved]: 'Approved',
    [BookingStatus.Rejected]: 'Rejected',
    [BookingStatus.Cancelled]: 'Cancelled',
    [BookingStatus.PendingCancellation]: 'Pending Cancellation',
    [BookingStatus.Withdrawn]: 'Withdrawn',
};
export const activeBookingStatuses = [
    BookingStatus.Pending,
    BookingStatus.Approved,
    BookingStatus.PendingCancellation,
];
export const emptyHolidayYearEntity = () => {
    return {
        userName: '',
        timeAdded: new Date(),
        start: new Date(),
        end: new Date(),
        entitlement: 0,
        entitlementSetOn: new Date(),
        knownAsName: '',
        managerName: '',
        managerEmail: '',
        remaining: 0,
        doNotShowSetupYearDialog: true,
        countryCode: '',
        regionCode: '',
    };
};
export class HolidayBooking {
    constructor() {
        this.bookingId = '';
        this.userId = '';
        this.userName = '';
        this.timeAdded = new Date();
        this.startDate = new Date();
        this.endDate = new Date();
        this.startDateString = '';
        this.endDateString = '';
        this.isStartHalfDay = false;
        this.isEndHalfDay = false;
        this.isManagerApprovalRequired = false;
        this.managerEmail = '';
        this.approvalStatus = BookingStatus.Pending;
        this.approvalStatusNumber = BookingStatus.Pending;
        this.sameDayOption = '';
        this.deductFromEntitlement = false;
        this.canSendApprovalRequestReminder = false;
        this.canSendCancellationApprovalRequestReminder = false;
    }
}
